export default __webpack_public_path__ + "static/media/Elpedison_φα.15e86b72.png";